import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  inline-size: 100%;
  border-block-start: 1px #000000 solid;

  padding-block-start: 8px;

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 12px;
  }
`;

export const Title = styled.div`
  color: rgba(0, 0, 0, 0.8);
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;
`;

export const Topics = styled.div`
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 1.6;
`;

export const StyledEntityLink = styled(EntityLink)`
  color: #666666;

  transition: color 0.2s ease;

  &:hover {
    color: #000000;
    text-decoration: underline;
  }
`;

export const Separator = styled.span`
  margin-inline: 8px;

  color: #cccccc;
`;
